import treatments from "../services/treatments.js";
import projects from "../services/projects.js";

const papa = require('papaparse');

class Treatment
{
    async test_project(
        project_uid,
        formData,
        tags,
        results_files,
        name_file,
        first_csv,
        urls,
        nb_step, 
        step,
        params,
        treatment_params,
        step_uid
    ) {

        var project = await projects.get(project_uid);

        console.log(project)

        var results = []
        var tag_data = {};
        if (project.tags && tags) {
            for (var i = 0; i < project.tags.length; i++) {
                if (project.tags[i].tag == tags)
                    tag_data = project.tags[i];
            }
        }
        var treatment_data = await treatments.create(
            project.uid,
            null,
            null,
            null,
            [tags],
            tag_data.type_import || "import",
            formData,
            params,
            treatment_params,
            step_uid
        );
        while (
            treatment_data.treatment.resultat != "ok" &&
            treatment_data.treatment.resultat != "ko"
        ) {
            await new Promise((resolve) => setTimeout(resolve, 2000));
            treatment_data = await treatments.get(
                treatment_data.treatment.uid
            );
        }
        var all_files = await treatments.getFiles(
            treatment_data.treatment.uid
        );
        if (!all_files || all_files.length == 0) all_files = [];
        all_files.sort((a, b) =>
            a.nom_fichier > b.nom_fichier ? 1 : -1
        );
        var export_type = tag_data.type_export || "export";
        for (var i = 0; i < all_files.length; i++) {
            if (nb_step <= 1) {
                if (
                    first_csv &&
                    all_files[i].type == export_type &&
                    all_files[i].nom_fichier.endsWith(".csv") &&
                    !step.file_result
                ) {
                    var csv_data = await treatments.getFile(
                        all_files[i].uid,
                        all_files[i].nom_fichier,
                        false,
                        false
                    );
                    name_file = all_files[i].nom_fichier;
                    results = papa.parse(csv_data, {
                        header: true,
                    });
                    results = results.data;
                    first_csv = false;
                } else if (all_files[i].type == export_type) {
                    urls.push({
                        url: all_files[i].url,
                        name: all_files[i].nom_fichier,
                    });
                }
            } else {
                if (all_files[i].type == export_type)
                    urls.push({
                        url: all_files[i].url,
                        name: all_files[i].nom_fichier,
                    });
            }
        }

        return { name_file, first_csv, urls, results };
    }
}

export default new Treatment();